var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F4F5F6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0A68FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.94 7.871-6.126 6.126V19.5h1.343v-3.625c0-1.032.847-1.844 1.845-1.844s1.845.842 1.845 1.844V19.5h7.218v-5.503c-2.376-2.372-3.72-3.72-6.126-6.126zm4.812 10.376H11.94v-4.216h4.812v4.216z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.095 14.531h-1.654v3.222h1.654v-3.222zM14.596 14.531v3.222h1.659v-3.222H14.596zM19.223 11.313 12.69 4.782a1.02 1.02 0 0 0-1.408 0l-6.501 6.531a1.02 1.02 0 0 0 0 1.409c.27.269.68.341 1.032.223a.928.928 0 0 0 .376-.223l5.814-5.815 5.81 5.815c.077.072.16.129.251.17.372.183.854.13 1.158-.174.376-.406.376-1.033 0-1.408v.003z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleHome);
export default ForwardRef;